import { ChangeDetectionStrategy, Component, computed, effect, input, signal } from '@angular/core';
import { TreeComponent } from '../../../probability/tree/tree/tree.component';
import { buildPinCodeTree, computeColumns, DigitColumn, PinCodeWidgetParams } from './pin-code.model';

@Component({
  selector: 'dojo-pin-code-widget',
  standalone: true,
  imports: [TreeComponent],
  templateUrl: './pin-code.component.html',
  styleUrls: ['./pin-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block h-full w-full' },
})
export class PinCodeWidgetComponent {
  constructor() {
    effect(() => {
      const count = this.params().digitCount;
      this.selections.set(Array.from({ length: count }, () => null));
    });
  }

  readonly params = input.required<PinCodeWidgetParams>();
  readonly selections = signal<Array<number | null>>([]);

  readonly columns = computed<DigitColumn[]>(() =>
    computeColumns(this.params().digitCount, this.params().allowRepeats, this.selections(), this.params().restrictions),
  );

  private readonly treeResult = computed(() =>
    buildPinCodeTree(
      this.params().digitCount,
      this.params().allowRepeats,
      this.selections(),
      this.params().restrictions,
    ),
  );

  readonly treeParams = computed(() => this.treeResult().tree);

  readonly selectedTreePath = computed(() => {
    const path = this.treeResult().selectedPath;
    return path.length > 0 ? [path] : [];
  });

  selectDigit(columnIndex: number, digit: number): void {
    const current = this.selections();
    const updated = [...current];
    updated[columnIndex] = updated[columnIndex] === digit ? null : digit;

    for (let i = columnIndex + 1; i < updated.length; i++) {
      updated[i] = null;
    }

    this.selections.set(updated);
  }
}
